
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/settings/settings.component.css
// module id = 735
// module chunks = 0